export default __webpack_public_path__ + "static/media/white_event.250be059.svg";